var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeleteBtnLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.001,
    height: 35,
    viewBox: "0 0 32.001 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75605",
    "data-name": "Group 75605",
    transform: "translate(-693.25 -238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_78564",
    "data-name": "Path 78564",
    transform: "translate(-1443.594 -106.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81819",
    "data-name": "Path 81819",
    d: "M2160.284,379.222H2144.16a2.46,2.46,0,0,1-2.457-2.457v-.035l-1.375-19.376-.033-.465h-1.113a1.839,1.839,0,0,1-1.836-1.838v-2.4a1.838,1.838,0,0,1,1.836-1.835h5.477l.13-.3,1.4-3.258.036-.077c.608-1.325.94-1.962,1.841-1.962h8.342c.942,0,1.337.768,1.876,2.032l1.385,3.263.129.3h5.469a1.838,1.838,0,0,1,1.836,1.835v2.4a1.839,1.839,0,0,1-1.836,1.838h-1.113l-.033.465-1.374,19.376v.035A2.46,2.46,0,0,1,2160.284,379.222Z",
    fill: "#f45e29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81820",
    "data-name": "Path 81820",
    d: "M2148.062,345.722c-.527,0-.735.25-1.387,1.67l-.033.072-1.656,3.857h-5.806a1.337,1.337,0,0,0-1.336,1.335v2.4a1.338,1.338,0,0,0,1.336,1.338h1.579l1.444,20.34v.035a1.959,1.959,0,0,0,1.957,1.957h16.124a1.96,1.96,0,0,0,1.958-1.957l0-.071,1.44-20.3h1.579a1.338,1.338,0,0,0,1.336-1.338v-2.4a1.337,1.337,0,0,0-1.336-1.335h-5.8l-1.643-3.871c-.585-1.373-.877-1.728-1.417-1.728h-8.342m0-1h8.342c1.289,0,1.8,1.087,2.336,2.336l1.385,3.263h5.138a2.335,2.335,0,0,1,2.336,2.335v2.4a2.337,2.337,0,0,1-2.336,2.338h-.647l-1.374,19.376a2.957,2.957,0,0,1-2.958,2.957H2144.16a2.956,2.956,0,0,1-2.957-2.957l-1.375-19.376h-.647a2.338,2.338,0,0,1-2.336-2.338v-2.4a2.336,2.336,0,0,1,2.336-2.335h5.147l1.4-3.263C2146.332,345.744,2146.773,344.722,2148.062,344.722Z",
    fill: "#f45e29",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75542",
    "data-name": "Group 75542",
    transform: "translate(705.891 255.348)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_863",
    "data-name": "Line 863",
    y2: 12.069,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_864",
    "data-name": "Line 864",
    y2: 12.069,
    transform: "translate(6.001)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_78565",
    "data-name": "Path 78565",
    d: "M-192.475-15397.025h32",
    transform: "translate(885.726 15648.401)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteBtnLg);
export default __webpack_public_path__ + "static/media/icon-delete-btn-lg.e60184a6.svg";
export { ForwardRef as ReactComponent };